type HasTypename = { __typename: string };
type TypenameOf<T> = T extends { __typename: infer N } ? (N extends string ? N : never) : never;
type VariantOf<T, N extends string> = Extract<T, { __typename: N }>;
type HandlerMap<TUnion extends HasTypename> = {
    [N in TypenameOf<TUnion>]: (value: VariantOf<TUnion, N>) => any;
};
type HandlerReturn<THandlers extends Record<string, (...args: any[]) => any>> = ReturnType<THandlers[keyof THandlers]>;

export function splitGqlUnion<TUnion extends HasTypename, THandlers extends HandlerMap<TUnion>>(
    value: TUnion,
    handlers: THandlers,
): HandlerReturn<THandlers> {
    const key = value.__typename as TypenameOf<TUnion>;
    const fn = handlers[key] as unknown as (v: TUnion) => HandlerReturn<THandlers>;

    return fn(value);
}
